import { Button, KIND } from "baseui/button";
import { Block } from 'baseui/block';
import { VscChevronLeft, VscChevronRight } from 'react-icons/vsc';
import { DatePicker } from 'baseui/datepicker';
import { FormattedMessage, useIntl } from 'react-intl';
import { useGetLanguage } from '../../../hooks/useGetLanguage';
import { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight } from "baseui/icon";

export interface ITimeNavigationProps {
    start: Date,
    end: Date,
    goBack: () => void,
    goForward: () => void,
    goLive: () => void,
    onTimeChanged: (item?: onTimeChangedArgs) => void,
}
export type onTimeChangedArgs = {
    start: Date,
    end: Date
}
function TimeNavigation(props: ITimeNavigationProps) {
    const intl = useIntl();

    const [timeRange, setTimeRange] = useState([props.start, props.end]);

    const { language, locale } = useGetLanguage();
    const onTimeChangedStart = ({ date }) => {
        setTimeRange(Array.isArray(date) ? date : [date])
        if (Array.isArray(date) && date.length > 1)
            props.onTimeChanged({ start: date[0], end: date[1] });
    };


    useEffect(() => {
        setTimeRange([props.start, props.end]);
    }, [props.start, props.end]);

    const isNow = timeRange.length >= 2 ? (new Date().getTime() - timeRange[1].getTime()) < 60000 : false; // same minute
    const canGoForward = !isNow;

    return (
        <Block display={'inline-flex'}   width={'100%'}   >
            <Button size='compact' kind={KIND.tertiary} onClick={props.goBack} ><ChevronLeft></ChevronLeft></Button>
            <DatePicker
                size='compact'
                range
                value={timeRange}
                onChange={onTimeChangedStart}
                locale={locale}
                formatString='dd MMMM yy'
                quickSelect
                maxDate={new Date()}
            />
            <Button size='compact' kind={KIND.tertiary} onClick={props.goForward} disabled={!canGoForward}><ChevronRight /></Button>
            <Button size='compact' kind={KIND.secondary} onClick={props.goLive} disabled={isNow}><FormattedMessage id='now' defaultMessage={'Now'}></FormattedMessage></Button>
        </Block>)

}
export default TimeNavigation